<template>
    <div class="app-layout">
        <div class="sidebar">
            <div class="sidebar--container">
                <div class="sidebar--navigation">
                    <div class="meta">
                        <meta-logo />
                        <form-button id="sidebar-toggle" color="primary" icon="menu-burger-arrow-circle" />
                    </div>
                    <div class="menu">
                        <nav>
                            <ul>
                                <li>
                                    <ask-for-quote-sidebar :ask-for-quote="askForQuote" />
                                </li>
                                <li>
                                    <search-input />
                                </li>
                                <li>
                                    <sidebar-nav-item routing="dashboard" icon="dashboard-6"><span>Dashboard</span></sidebar-nav-item>
                                </li>
                                <li>
                                    <a href="#" class="btn btn--icon" style="opacity: .5;"><svg-vue icon="warehouse-delivery" class="icon" /><span>Lager</span></a>
                                </li>
                                <li>
                                    <sidebar-nav-item routing="producer-user.create" icon="single-user-add-plus"><span>Produzent anlegen</span></sidebar-nav-item>
                                </li>
                                <li>
                                    <sidebar-nav-item routing="admin-user.index" icon="settings-circle-2"><span>Einstellungen</span></sidebar-nav-item>
                                </li>
                                <li>
                                    <sidebar-nav-item routing="logout" icon="lock-unlock"><translate>Logout</translate></sidebar-nav-item>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div class="sidebar--content">
                    <slot></slot>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import MetaLogo from '@partfactory/Shared/Header/MetaLogo';
import FormButton from '@partfactory/Shared/Form/FormButton';
import SidebarNavItem from '@partfactory/Shared/Sidebar/SidebarNavItem';
import SearchInput from '@partfactory/Pages/Admin/PortalSearch/SearchInput';
import AskForQuoteSidebar from '@partfactory/Pages/Admin/AskForQuote/Sidebar/AskForQuoteSidebar';

export default {
    name: 'AppAdminLayout',
    components: {
        AskForQuoteSidebar,
        SearchInput,
        SidebarNavItem,
        FormButton,
        MetaLogo
    },
    props: {
        askForQuote: Object,
    }
};
</script>
